import { useForm } from 'react-hook-form';

import {
  Box,
  Button,
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Text,
  Link,
  Divider,
} from '@chakra-ui/react';
import { Link as RLink } from 'react-router-dom';
import { useRef, useState } from 'react';
import { removeErrorParam } from '../helpers';
import Container from '../components/Container';
import { useIdp } from '../services';
import Spinner from '../components/Spinner';

const LoginPage = () => {
  const search = new URLSearchParams(window.location.search);
  const [error, setError] = useState(search.has('error'));
  const ref = useRef();
  const idpInfo = useIdp();

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    setError(false);
    const asd = window.AmazonCognitoAdvancedSecurityData.getData(data.user, '', search.get('client_id'));
    ref.current.asd.value = asd;
    ref.current.submit();
    return true;
  };

  const onHandleSubmit = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    handleSubmit(onSubmit)();
  };

  // eslint-disable-next-line no-unused-vars
  const onLoginWithExternalIDP = (idp) => {
    window.location = `/oauth2/authorize${window.location.search}&identity_provider=${idp}`;
  };

  return (
    <Container>
      {!idpInfo && <Spinner />}
      {idpInfo && idpInfo.idps.includes('Google') && (
        <>
          <Heading className="card-title text-center" mb="2" fontWeight="normal" fontSize="lg">
            Sign in with your social accounts
          </Heading>
          <Box my="4">
            <Button colorScheme="blue" size="sm" onClick={() => onLoginWithExternalIDP('Google')}>Login with Google</Button>
          </Box>
          {idpInfo && idpInfo.idps.includes('Vulcan') && <Divider my="6" borderColor="gray.300" />}
        </>
      )}
      {idpInfo && idpInfo.idps.includes('Vulcan') && (
        <>
          {/* eslint-disable-next-line max-len */}
          <form ref={ref} onSubmit={onHandleSubmit} action={`${process.env.REACT_APP_BACKEND}/auth/login${window.location.search}`} method="POST">
            <Heading className="card-title text-center" mb="2" fontSize="lg" fontWeight="normal">
              Sign in with your email and password
            </Heading>
            {error && <Text my="2" fontSize="lg" color="red.500">Email or password invalid.</Text>}

            <FormControl my="4" isInvalid={errors.email}>
              <FormLabel mb="0.5" fontSize="sm">Email</FormLabel>
              <Input size="sm" type="email" placeholder="Email" {...register('email', { required: true })} />
              <FormErrorMessage>The email address is required</FormErrorMessage>
            </FormControl>

            <FormControl my="4" isInvalid={errors.password}>
              <FormLabel mb="0.5" fontSize="sm">Password</FormLabel>
              <Input size="sm" type="password" placeholder="Password" {...register('password', { required: true })} />
              <FormErrorMessage>The password is required</FormErrorMessage>
            </FormControl>
            <Box my="4">
              <Link as={RLink} to={`/forgotPassword${removeErrorParam(window.location.search)}`}>Forgot your password?</Link>
            </Box>
            <input type="hidden" className="form-control" name="asd" />
            <Button colorScheme="blue" type="submit" size="sm" isLoading={isSubmitting} px="10">Ingresar</Button>
          </form>
        </>
      )}
      {idpInfo && idpInfo.signUpEnabled && (
        <Box>
          <Divider my="4" />
          <Text>
            Need an account?
            <Link as={RLink} to={`/signup${removeErrorParam(window.location.search)}`} ml="2" color="blue.600">Sign up</Link>
          </Text>
        </Box>
      )}
    </Container>
  );
};

export default LoginPage;
